<template>
  <div class="contentWrap">
    <el-tabs v-model="activeName">
      <!-- 理事会 -->
      <el-tab-pane label="理事会" name="first">
        <div class="council-position">理事长</div>
        <div class="council-name-list">
          <span class="council-name-item">魏钟林</span>
        </div>

        <div class="council-position">副理事长( 以姓氏笔画为序 )</div>
        <div class="council-name-list">
          <span class="council-name-item">王 颖</span>
          <span class="council-name-item">吕文杰</span>
          <span class="council-name-item">章 进</span>
        </div>

        <div class="council-position">秘书长</div>
        <div class="council-name-list">
          <span class="council-name-item">秦卫星</span>
        </div>

        <div class="council-position">理事 ( 以姓氏笔画为序 )</div>
        <div class="council-name-list">
          <span class="council-name-item">孙艳艳</span>
          <span class="council-name-item">李凤友</span>
          <span class="council-name-item">余甜田</span>
          <span class="council-name-item">邱仕兵</span>
          <span class="council-name-item">陈轶鑫</span>
          <span class="council-name-item">殷 鹤</span>
        </div>
      </el-tab-pane>

      <!-- 监事会 -->
      <el-tab-pane label="监事会" name="second">
        <div class="council-position">监事长</div>
        <div class="council-name-list">
          <span class="council-name-item">周军</span>
        </div>

        <div class="council-position">监事 ( 以姓氏笔画为序 )</div>
        <div class="council-name-list">
          <span class="council-name-item">范婷婷</span>
          <span class="council-name-item">陆  蔚</span>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>


<script>
import cnchar from "cnchar";
export default {
  name: "council",
  data() {
    return {
      councilContent: {
        council: [],
        viceCouncil: [],
        secretaryGeneral: [],
        trustee: [],
      },
      activeName: "first",
      supervisors: {
        chiefSupervisor: [],
        supervisor: [],
      },
      allCouncilName: "councilContent.councilName",
    };
  },
  created() {
    this.getCouncil();
    this.getSupervisors();
  },

  methods: {
    // 理事会接口
    getCouncil() {
      this.$axios({
        method: "post",
        url: "/laf/laf/lafCouncil/tableList.ajax",
        data: {
          pageSize: "200",
          pageNo: "1",
          condition: "type:S_IN0|councilOrder:@第三届||",
          _entityName: "org.aweto.laf.entity.LafCouncil",
        },
      })
        .then((res) => {
          console.log(res.rows.map((item) => item.councilName));
          const council = [];
          const viceCouncil = [];
          const secretaryGeneral = [];
          const trustee = [];
          res.rows.forEach((item) => {
            switch (item.councilPosition) {
              case "理事长":
                council.push(item.councilName);
                break;
              case "副理事长":
                viceCouncil.push(item.councilName);
                break;
              case "秘书长":
                secretaryGeneral.push(item.councilName);
                break;
              case "理事":
                trustee.push(item.councilName);
            }
          });
          this.councilContent = {
            council: this.sortNameByStroke(council),
            viceCouncil: this.sortNameByStroke(viceCouncil),
            secretaryGeneral: this.sortNameByStroke(secretaryGeneral),
            trustee: this.sortNameByStroke(trustee),
          }
        })

        .catch(function (error) {
          console.log(error);
        });
    },

    sortNameByStroke(names) {
      return names.sort((a, b) => {
        if (a && b) return a.charAt(0).stroke() < b.charAt(0).stroke() ? -1 : 0;
        else return 0;
      });
    },
    //  监事会接口
    getSupervisors() {
      this.$axios({
        method: "post",
        url: "/laf/laf/lafCouncil/tableList.ajax",
        data: {
          pageSize: "200",
          pageNo: "1",
          condition: "type:S_IN1|councilOrder:@第三届||",
          _entityName: "org.aweto.laf.entity.LafCouncil",
        },
      })
        .then((res) => {
          const chiefSupervisor = [];
          const supervisor = [];
          res.rows.forEach((item) => {
            switch (item.councilPosition) {
              case "监事长":
                chiefSupervisor.push(item.councilName);
                break;
              case "监事":
                supervisor.push(item.councilName);
                break;
            }
          });
          this.supervisors = {
            chiefSupervisor: this.sortNameByStroke(chiefSupervisor),
            supervisor: this.sortNameByStroke(supervisor),
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    formatName(ele) {
      ele = ele.replace(/[ ]+/g, "&nbsp;&nbsp;&nbsp;&nbsp;");
      return ele;
    },
  },
};
</script>

<style lang='scss' scoped>
.img-pic {
  width: 100px;
  height: 100px;
  border-radius: 50px;
}
.contentWrap {
  ::v-deep .el-tabs__nav {
    margin-left: 20px;
  }

  ::v-deep .el-tabs__item {
    font-size: 18px;
  }

  ::v-deep .el-tabs__item:hover {
    color: $red;
  }

  ::v-deep .el-tabs__item.is-active {
    color: $red;
  }

  ::v-deep .el-tabs__active-bar {
    background-color: $red;
  }

  ::v-deep .el-tabs__content {
    border-left: 0;
  }
}

.council-position {
  margin-left: 40px; // 用 margin 替代 text-indent 更直观
  font-size: 18px;
  line-height: 30px;
  font-weight: bold;
  color: #cd242a;
}

.council-name-list {
  margin: 16px 0 30px 40px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px 40px; // 行间距 20，列间距 40（你原来那坨nbsp的大致效果）
  font-size: 16px;
  color: #333;
}

.council-name-item {
  white-space: pre-wrap; // ✅ 保留中文名字里的多个空格
  line-height: 28px;
}

.linkTwo {
  border-top: solid #eee 1px;
}
.link {
  // width: 880px;
  margin-top: 20px;
  border-top: solid #e5e5e5 1px;
}
::v-deep .el-tabs__content {
  border-left: 0;
}
::v-deep {
  .el-tabs__active-bar {
    background-color: $red;
  }
}
.el-main {
  padding: 35px;
}
</style>